module.exports = __webpack_public_path__ + "0b2b341d4e125fa7020d481dbae985f1.pdf";